import React, { ReactElement, Ref, useContext } from 'react'
// Externals imports.
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined'
import AddIcon from '@material-ui/icons/Add'
import RemoveIcon from '@material-ui/icons/Remove'
import MoreHorizIcon from '@material-ui/icons/MoreHoriz'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined'
import MailOutlineSharpIcon from '@material-ui/icons/MailOutlineSharp'
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined'
import ListAltIcon from '@material-ui/icons/ListAlt'
import FilterListIcon from '@material-ui/icons/FilterList'
import LibraryAddCheckOutlinedIcon from '@material-ui/icons/LibraryAddCheckOutlined'
import LayersOutlinedIcon from '@material-ui/icons/LayersOutlined'
import NotificationsActiveOutlinedIcon from '@material-ui/icons/NotificationsActiveOutlined'
import EventOutlinedIcon from '@material-ui/icons/EventOutlined'
import LocalAtmOutlinedIcon from '@material-ui/icons/LocalAtmOutlined'
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined'
import RateReviewOutlined from '@material-ui/icons/RateReviewOutlined'
import BuildOutlinedIcon from '@material-ui/icons/BuildOutlined'
import ArrowRightOutlinedIcon from '@material-ui/icons/ArrowRightOutlined'
import ArrowLeftOutlinedIcon from '@material-ui/icons/ArrowLeftOutlined'
import KeyboardArrowUpOutlinedIcon from '@material-ui/icons/KeyboardArrowUpOutlined'
import KeyboardArrowDownOutlinedIcon from '@material-ui/icons/KeyboardArrowDownOutlined'
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox'
import LocalPrintshopOutlinedIcon from '@material-ui/icons/LocalPrintshopOutlined'
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import ChevronLeft from '@material-ui/icons/ChevronLeft'
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow'
import DashboardOutlined from '@material-ui/icons/DashboardOutlined'
import CreateOutlined from '@material-ui/icons/CreateOutlined'
import GrainIcon from '@material-ui/icons/Grain'
import LocalOfferOutlinedIcon from '@material-ui/icons/LocalOfferOutlined'
import SortIcon from '@material-ui/icons/Sort'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined'
import UnfoldMoreOutlined from '@material-ui/icons/UnfoldMoreOutlined'
import UnfoldLessOutlined from '@material-ui/icons/UnfoldLessOutlined'
import HearingOutlinedIcon from '@material-ui/icons/HearingOutlined'
import PauseCircleOutlineOutlinedIcon from '@material-ui/icons/PauseCircleOutlineOutlined'
import PlayCircleOutlineOutlinedIcon from '@material-ui/icons/PlayCircleOutlineOutlined'
import CloudDownloadOutlinedIcon from '@material-ui/icons/CloudDownloadOutlined'
import OpenInNewOutlinedIcon from '@material-ui/icons/OpenInNewOutlined'
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined'
import DeviceHub from '@material-ui/icons/DeviceHub'
import Language from '@material-ui/icons/Language'
import SwapHorizIcon from '@material-ui/icons/SwapHoriz'
import DragIndicator from '@material-ui/icons/DragIndicator'
import DeleteSweepOutlined from '@material-ui/icons/DeleteSweepOutlined'
import DeleteForeverOutlined from '@material-ui/icons/DeleteForeverOutlined'
import RestoreFromTrashOutlined from '@material-ui/icons/RestoreFromTrashOutlined'
import WarningOutlined from '@material-ui/icons/WarningOutlined'
import VisibilityOffOutlined from '@material-ui/icons/VisibilityOffOutlined'
import VisibilityOutlined from '@material-ui/icons/VisibilityOutlined'
import PersonOutlined from '@material-ui/icons/PersonOutlined'
import LockOutlined from '@material-ui/icons/LockOutlined'
import PhoneEnabledOutlined from '@material-ui/icons/PhoneEnabledOutlined'
import SupervisorAccountOutlined from '@material-ui/icons/SupervisorAccountOutlined'
import CasinoOutlined from '@material-ui/icons/CasinoOutlined'
import HowToIcon from '@material-ui/icons/HowToRegOutlined'
import Sync from '@material-ui/icons/Sync'
import CheckIcon from '@material-ui/icons/Check'
import Partition from '@material-ui/icons/LocationOnOutlined'
import GpsFixedOutlined from '@material-ui/icons/GpsFixed'
import Today from '@material-ui/icons/Today'
import WatchLater from '@material-ui/icons/WatchLater'
import Arrow from '@material-ui/icons/ArrowForward'
import InboundCall from '@material-ui/icons/PhoneCallback'
import DeviceInfo from '@material-ui/icons/PermDeviceInformationOutlined'
import RateReview from '@material-ui/icons/RateReview'
import FirstPage from '@material-ui/icons/FirstPage'
import LastPage from '@material-ui/icons/LastPage'
import ChevronRight from '@material-ui/icons/ChevronRight'
import NotificationsNoneOutlinedIcon from '@material-ui/icons/NotificationsNoneOutlined'
import NotificationsOffOutlinedIcon from '@material-ui/icons/NotificationsOffOutlined'
import LibraryAddOutlinedIcon from '@material-ui/icons/LibraryAddOutlined'
import SettingsApplicationsOutlined from '@material-ui/icons/SettingsApplicationsOutlined'
import Link from '@material-ui/icons/LinkOutlined'
import LinkOff from '@material-ui/icons/LinkOffOutlined'
import Send from '@material-ui/icons/SendOutlined'
import AddCircle from '@material-ui/icons/AddCircle'
import Business from '@material-ui/icons/Business'
import Devices from '@material-ui/icons/DevicesOutlined'
import ViewModuleIcon from '@material-ui/icons/ViewModule'
import AppsRounded from '@material-ui/icons/AppsRounded'
import RemoveFromQueue from '@material-ui/icons/RemoveFromQueue'
import Favorite from '@material-ui/icons/Favorite'
import FavoriteBorder from '@material-ui/icons/FavoriteBorder'
import Replay from '@material-ui/icons/ReplayOutlined'

// CSS imports. Commented out because of current build process.
// Custom Icons
import PinOutlined from './CustomSVGIcons/PinOutlined'
import PinFilled from './CustomSVGIcons/PinFilled'
import PinNumOutlined from './CustomSVGIcons/PinNumOutlined'
import CopyAllOutline from './CustomSVGIcons/CopyAllOutline'
import ConfigureIcon from './CustomSVGIcons/Configure'
import { DashboardAddReportIcon } from './CustomSVGIcons/DashboardAddReport'
import { DashboardChoose } from './CustomSVGIcons/DashboardChoose'
import Provisioning from './CustomSVGIcons/Provisioning'
import { TelServerIcon } from './CustomSVGIcons/TelServerIcon'
import { AdminIcon } from './CustomSVGIcons/AdminIcon'
import { RoleIcon } from './CustomSVGIcons/RoleIcon'
import { PasswordRandomise } from './CustomSVGIcons/PasswordRandomise'
import { HashTagIcon } from './CustomSVGIcons/HashTagIcon'
import { QuestionMark } from './CustomSVGIcons/QuestionMark'
import { TourIcon } from './CustomSVGIcons/TourIcon'
import { NotificationAddOutlined } from './CustomSVGIcons/NotificationAddOutlined'
import { InsightsHubOnIcon } from './CustomSVGIcons/InsightsHubOnIcon'
import { InsightsHubOffIcon } from './CustomSVGIcons/InsightsHubOffIcon'
import { LightMode } from './CustomSVGIcons/LightMode'
import { DarkMode } from './CustomSVGIcons/DarkMode'
import { Logout } from './CustomSVGIcons/Logout'
import { QueueUnmonitorAll } from './CustomSVGIcons/ManageQueue/UnmonitorAll'
import { QueueMonitorAll } from './CustomSVGIcons/ManageQueue/MonitorAll'
import { TimeZoneIcon } from './CustomSVGIcons/TimeZone'

// Timeline Call Segment
import { AbandonedIcon } from './CustomSVGIcons/TimelineCallSegment/Abandoned'
import { AdvancedBouncedIcon } from './CustomSVGIcons/TimelineCallSegment/AdvancedBounced'
import { AnsweredIcon } from './CustomSVGIcons/TimelineCallSegment/Answered'
import { CallEndedIcon } from './CustomSVGIcons/TimelineCallSegment/CallEnded'
import { CallStartInboundIcon } from './CustomSVGIcons/TimelineCallSegment/CallStartInbound'
import { CallStartOutboundIcon } from './CustomSVGIcons/TimelineCallSegment/CallStartOutbound'
import { ConferencedIcon } from './CustomSVGIcons/TimelineCallSegment/Conferenced'
import { DivertedIcon } from './CustomSVGIcons/TimelineCallSegment/Diverted'
import { EndedOnHoldIcon } from './CustomSVGIcons/TimelineCallSegment/EndedOnHold'
import { EscapedIcon } from './CustomSVGIcons/TimelineCallSegment/Escaped'
import { MovedIcon } from './CustomSVGIcons/TimelineCallSegment/Moved'
import { OverflowedIcon } from './CustomSVGIcons/TimelineCallSegment/Overflowed'
import { TransferredIcon } from './CustomSVGIcons/TimelineCallSegment/Transferred'
import { UnmonitoredUnknownDestinationIcon } from './CustomSVGIcons/TimelineCallSegment/UnmonitoredUnknownDestination'

// Sub imports.
import { IconName, IconSize } from '../../../../NonReact/constants/React/Icon/Constants'
// Contexts imports.
// Utilities imports.
import { LanguageGeneral } from '../../../../../i18n'
import { NumPad } from './CustomSVGIcons/NumPad'
import { RoleAddIcon } from './CustomSVGIcons/RoleAddIcon'
import LanguageContext, { LanguageContextType } from '../../Contexts/LanguageContext'
import { TelSysDetailsIcon } from './CustomSVGIcons/TelSysDetailsIcon'
import { SettingsSuggestIcon } from './CustomSVGIcons/SettingsSuggestIcon'
import { EMPTY_STRING } from '../../../../NonReact/constants/Common'
import { LicencesIcon } from './CustomSVGIcons/LicencesIcon'
import { AddAllIcon } from './CustomSVGIcons/AddAllIcon'
import { SortingAZ } from './CustomSVGIcons/SortingAZ'
import { SortingZA } from './CustomSVGIcons/SortingZA'
import { APIKeysIcon } from './CustomSVGIcons/APIKeysIcon'
import { MenuLauncher } from './CustomSVGIcons/MenuLauncher'
import { HelpAvatarMenu } from './CustomSVGIcons/HelpAvatarMenu'
import { ChangeLanguage } from './CustomSVGIcons/ChangeLanguage'
import { ChangePassword } from './CustomSVGIcons/ChangePassword'
import { ShowInsights } from './CustomSVGIcons/ShowInsights'
import { HideInsights } from './CustomSVGIcons/HideInsights'
import { Reporting } from './CustomSVGIcons/Reporting'
import { FastProvisioning } from './CustomSVGIcons/FastProvisioning'
import { Administration } from './CustomSVGIcons/Administration'
import { StatusAndTools } from './CustomSVGIcons/StatusAndTools'
import { ReportingSidebarIcon } from './CustomSVGIcons/ReportingSidebarMenu/ReportingSidebarIcon'
import { InsightsSidebarIcon } from './CustomSVGIcons/ReportingSidebarMenu/InsightsSidebarIcon'
import { PresenceSidebarIcon } from './CustomSVGIcons/ReportingSidebarMenu/PresenceSidebarIcon'
import { EnterpriseManagementSidebar } from './CustomSVGIcons/FastProvisioning/EnterpriseManagementSidebar'
import { UserManagementSidebar } from './CustomSVGIcons/FastProvisioning/UserManagementSidebar'
import { QueueManagementSidebar } from './CustomSVGIcons/FastProvisioning/QueueManagementSidebar'
import { DeviceSidebar } from './CustomSVGIcons/Administration/DeviceSidebar'
import { AgentSidebar } from './CustomSVGIcons/Administration/AgentSidebar'
import { PartitionSidebar } from './CustomSVGIcons/Administration/PartitionSidebar'
import { CMESidebar } from './CustomSVGIcons/Administration/CMESidebar'
import { CodesSidebar } from './CustomSVGIcons/Administration/CodesSidebar'
import { DirectorySidebar } from './CustomSVGIcons/Administration/DirectorySidebar'
import { UsersSidebar } from './CustomSVGIcons/Administration/UsersSidebar'
import { TelsysSidebar } from './CustomSVGIcons/Administration/TelsysSidebar'
import { RecordingSidebar } from './CustomSVGIcons/Administration/RecordingSidebar'
import { MessagesSidebar } from './CustomSVGIcons/Administration/MessagesSidebar'
import { LicencesSidebar } from './CustomSVGIcons/StatusAndTools/LicencesSidebar'
import { LoggingSidebar } from './CustomSVGIcons/StatusAndTools/LoggingSidebar'
import { LogManagementSidebar } from './CustomSVGIcons/StatusAndTools/LogManagementSidebar'
import { AuditTrailSidebar } from './CustomSVGIcons/StatusAndTools/AuditTrailSidebar'
import { CallControlSidebar } from './CustomSVGIcons/StatusAndTools/CallControlSidebar'
import { ServerStatusSidebar } from './CustomSVGIcons/StatusAndTools/ServerStatusSidebar'
import { TelephonyModuleStateSidebar } from './CustomSVGIcons/StatusAndTools/TelephonyModuleStateSidebar'
import { DatabaseSidebar } from './CustomSVGIcons/Administration/DatabaseSidebar'
import { ExpandMenu } from './CustomSVGIcons/ExpandMenu'
import { CollapseMenu } from './CustomSVGIcons/CollapseMenu'
import { MissedCalls } from './CustomSVGIcons/Insights/MissedCalls'
import { AverageAnswered } from './CustomSVGIcons/Insights/AverageAnswered'
import { AverageAbandoned } from './CustomSVGIcons/Insights/AverageAbandoned'
import { LongestWait } from './CustomSVGIcons/Insights/LongestWait'
import { CallsReceived } from './CustomSVGIcons/Insights/CallsReceived'
import { ProvisionAllCrm } from './CustomSVGIcons/ProvisionAllCrm'
import { BrandingIcon } from './CustomSVGIcons/BrandingIcon'
import { PreviewIcon } from './CustomSVGIcons/PreviewIcon'
import { ClearCurrentChanges } from './CustomSVGIcons/ClearCurrentChanges'
import { DeletePreview } from './CustomSVGIcons/DeletePreview'

// CSS imports. Commented out because of current build process.
// import './icon.scss';

/**
 * Component properties type.
 */
type Props = {
    inputRef?: Ref<HTMLDivElement>
    iconName: IconName
    iconSize?: IconSize
    className?: string
}

/**
 * Generic Icon component.
 * @param iconName Name of the icon compatible with eIconName enum values.
 * @param iconSize Size of the icon compatible with eIconSize enum values.
 * @param className Optional class name to be added to the icon.
 * @param inputRef Optional reference to the icon element.
 */
const Icon: React.FC<Props> = ({ iconName, iconSize, inputRef, className }: Props): ReactElement => {
    const language: LanguageContextType = useContext(LanguageContext)

    let size: Definable<IconSize> = iconSize
    // Default icon size to medium if size isn't defined
    if (!size) {
        size = IconSize.MEDIUM
    }

    /**
     * Builds the icon element based on the icon name provided.
     */
    const getIcon: () => ReactElement = (): ReactElement => {
        switch (iconName) {
            case IconName.GPS_FIXED_OUTLINED:
                return <GpsFixedOutlined />
            case IconName.PIN_NUM_OUTLINED:
                return <PinNumOutlined />
            case IconName.FOLDER:
                return <InsertDriveFileOutlinedIcon />
            case IconName.X:
                return <ClearOutlinedIcon />
            case IconName.OPEN_IN_NEW:
                return <OpenInNewOutlinedIcon />
            case IconName.ADD:
                return <AddIcon />
            case IconName.DELETE:
                return <DeleteOutlinedIcon />
            case IconName.REMOVE:
                return <RemoveIcon />
            case IconName.MORE_HORIZONTAL:
                return <MoreHorizIcon />
            case IconName.ERRORCIRCLE:
                return <ErrorOutlineIcon />
            case IconName.INFO:
                return <InfoOutlinedIcon />
            case IconName.SUCCESS:
                return <CheckCircleOutlinedIcon />
            case IconName.EMAIL:
                return <MailOutlineSharpIcon />
            case IconName.HOME:
                return <HomeOutlinedIcon />
            case IconName.ALARM:
                return <NotificationsActiveOutlinedIcon />
            case IconName.FIELDS:
                return <LibraryAddCheckOutlinedIcon />
            case IconName.DASHBOARD:
                return <DashboardOutlined />
            case IconName.FILTER:
                return <FilterListIcon />
            case IconName.LAYER:
                return <LayersOutlinedIcon />
            case IconName.MONEY:
                return <LocalAtmOutlinedIcon />
            case IconName.REPORT:
                return <ListAltIcon />
            case IconName.SCHEDULE:
                return <EventOutlinedIcon />
            case IconName.SETTINGS:
                return <SettingsOutlinedIcon />
            case IconName.RATING:
                return <RateReviewOutlined />
            case IconName.WRENCH:
                return <BuildOutlinedIcon />
            case IconName.ARROW_BACK:
                return <ChevronLeft />
            case IconName.ARROW_LEFT:
                return <ArrowLeftOutlinedIcon />
            case IconName.DOUBLE_ARROW_LEFT:
                return <DoubleArrowIcon className='flip-horizontal' />
            case IconName.DOUBLE_ARROW_RIGHT:
                return <DoubleArrowIcon />
            case IconName.ARROW_RIGHT:
                return <ArrowRightOutlinedIcon />
            case IconName.ARROW_UP:
                return <KeyboardArrowUpOutlinedIcon />
            case IconName.ARROW_DOWN:
                return <KeyboardArrowDownOutlinedIcon />
            case IconName.UNFOLD_ALL:
                return <UnfoldLessOutlined />
            case IconName.FOLD_ALL:
                return <UnfoldMoreOutlined />
            case IconName.RECORDING:
                return <HearingOutlinedIcon />
            case IconName.PRINT:
                return <LocalPrintshopOutlinedIcon />
            case IconName.ADD_OUTLINED:
                return <AddCircleOutlineOutlinedIcon />
            case IconName.CHECKBOX_BLANK:
                return <CheckBoxOutlineBlankIcon />
            case IconName.CHECKBOX_CHECKED:
                return <CheckBoxIcon />
            case IconName.CHECKBOX_MINUS:
                return <IndeterminateCheckBoxIcon />
            case IconName.ARROW_DROPDOWN:
                return <ArrowDropDownIcon />
            case IconName.ARROW_DROPUP:
                return <ArrowDropUpIcon />
            case IconName.PENCIL:
                return <CreateOutlined />
            case IconName.PIN:
                return <PinOutlined />
            case IconName.PINNED:
                return <PinFilled />
            case IconName.OTHER:
                return <GrainIcon />
            case IconName.TAG:
                return <LocalOfferOutlinedIcon />
            case IconName.SORT:
                return <SortIcon />
            case IconName.HELP:
                return <HelpOutlineIcon />
            case IconName.COPY:
                return <CopyAllOutline />
            case IconName.PAUSE:
                return <PauseCircleOutlineOutlinedIcon />
            case IconName.PLAY:
                return <PlayCircleOutlineOutlinedIcon />
            case IconName.DOWNLOAD:
                return <CloudDownloadOutlinedIcon />
            case IconName.CONFIGURE:
                return <ConfigureIcon />
            case IconName.LANGUAGE:
                return <Language />
            case IconName.DEVICEHUB:
                return <DeviceHub />
            case IconName.CHANGE:
                return <SwapHorizIcon />
            case IconName.DRAG:
                return <DragIndicator />
            case IconName.DASHBOARD_ADD:
                return <DashboardAddReportIcon />
            case IconName.CHOOSE:
                return <DashboardChoose />
            case IconName.SYNC:
                return <Sync />
            case IconName.PROVISIONING:
                return <Provisioning />
            case IconName.VISIBLE:
                return <VisibilityOutlined />
            case IconName.VISIBLE_OFF:
                return <VisibilityOffOutlined />
            case IconName.PERSON:
                return <PersonOutlined />
            case IconName.LOCKED:
                return <LockOutlined />
            case IconName.PHONE:
                return <PhoneEnabledOutlined />
            case IconName.ADMIN:
                return <AdminIcon />
            case IconName.DICE:
                return <CasinoOutlined />
            case IconName.ROLE:
                return <SupervisorAccountOutlined />
            case IconName.CUSTOMISE_ROLE:
                return <RoleIcon />
            case IconName.HOW_TO:
                return <HowToIcon />
            case IconName.PASSWORD_RANDOMISE:
                return <PasswordRandomise />
            case IconName.DELETE_SWEEP:
                return <DeleteSweepOutlined />
            case IconName.DELETE_FOREVER:
                return <DeleteForeverOutlined />
            case IconName.RESTORE_FROM_TRASH:
                return <RestoreFromTrashOutlined />
            case IconName.WARNING:
                return <WarningOutlined />
            case IconName.TELSERVER:
                return <TelServerIcon />
            case IconName.PARTITION:
                return <Partition />
            case IconName.HASH_TAG:
                return <HashTagIcon />
            case IconName.FEEDBACK:
            case IconName.MOREOPTIONS:
                return (
                    <img
                        src={`${language?.get(LanguageGeneral.ApplicationDefaultDirectory)}${iconName}`}
                        alt={iconName ?? EMPTY_STRING}
                    />
                )
            case IconName.CHECK:
                return <CheckIcon />
            case IconName.OMNICHANNEL:
                return <Devices />
            case IconName.CLOCK:
                return <WatchLater />
            case IconName.TODAY:
                return <Today />
            case IconName.ARROW:
                return <Arrow />
            case IconName.NUM_PAD:
                return <NumPad />
            case IconName.INBOUND_CALL:
                return <InboundCall />
            case IconName.DEVICE_INFO:
                return <DeviceInfo />
            case IconName.RATE_REVIEW:
                return <RateReview />
            case IconName.TOUR:
                return <TourIcon />
            case IconName.FIRST_PAGE:
                return <FirstPage />
            case IconName.LAST_PAGE:
                return <LastPage />
            case IconName.CHEVRON_RIGHT:
                return <ChevronRight />
            case IconName.CHEVRON_LEFT:
                return <ChevronLeft />
            case IconName.QUESTION_MARK:
                return <QuestionMark />
            case IconName.NOTIFICATION_ADD:
                return <NotificationAddOutlined />
            case IconName.NOTIFICATION_DISABLED:
                return <NotificationsOffOutlinedIcon />
            case IconName.NOTIFICATION_ENABLED:
                return <NotificationsNoneOutlinedIcon />
            case IconName.LIBRARY_ADD_OUTLINED:
                return <LibraryAddOutlinedIcon />
            case IconName.ROLE_ADD:
                return <RoleAddIcon />
            case IconName.TELSYS_DETAILS:
                return <TelSysDetailsIcon />
            case IconName.SETTINGS_SUGGEST:
                return <SettingsSuggestIcon />
            case IconName.TELSYS_COMMUNICATIONS:
                return <SettingsApplicationsOutlined />
            case IconName.LINKED:
                return <Link />
            case IconName.NOT_LINKED:
                return <LinkOff />
            case IconName.SEND:
                return <Send />
            case IconName.LICENCES:
                return <LicencesIcon />
            case IconName.ADD_ALL:
                return <AddAllIcon />
            case IconName.PROVISION_ALL_CRM:
                return <ProvisionAllCrm />
            case IconName.ADD_CIRCLE:
                return <AddCircle />
            case IconName.DEPARTMENT:
                return <Business />
            case IconName.SORTING_AZ:
                return <SortingAZ />
            case IconName.SORTING_ZA:
                return <SortingZA />
            case IconName.INSIGHTS_HUB_OFF:
                return <InsightsHubOffIcon />
            case IconName.INSIGHTS_HUB_ON:
                return <InsightsHubOnIcon />
            case IconName.MODULE:
                return <ViewModuleIcon />
            case IconName.APPS:
                return <AppsRounded />
            case IconName.API_KEYS:
                return <APIKeysIcon />
            case IconName.LIGHT_MODE:
                return <LightMode />
            case IconName.DARK_MODE:
                return <DarkMode />
            case IconName.LOGOUT:
                return <Logout />
            case IconName.REMOVE_FROM_QUEUE:
                return <RemoveFromQueue />
            case IconName.MENU_LAUNCHER:
                return <MenuLauncher />
            case IconName.HELP_AVATAR_MENU:
                return <HelpAvatarMenu />
            case IconName.CHANGE_LANGUAGE:
                return <ChangeLanguage />
            case IconName.CHANGE_PASSWORD:
                return <ChangePassword />
            case IconName.HIDE_INSIGHTS:
                return <HideInsights />
            case IconName.SHOW_INSIGHTS:
                return <ShowInsights />
            case IconName.REPORTING:
                return <Reporting />
            case IconName.FAST_PROVISIONING:
                return <FastProvisioning />
            case IconName.ADMINISTRATION:
                return <Administration />
            case IconName.STATUS_TOOLS:
                return <StatusAndTools />
            case IconName.REPORTING_SIDEBAR:
                return <ReportingSidebarIcon />
            case IconName.INSIGHTS_SIDEBAR:
                return <InsightsSidebarIcon />
            case IconName.PRESENCE_SIDEBAR:
                return <PresenceSidebarIcon />
            case IconName.ENTERPRISE_MANAGEMENT_SIDEBAR:
                return <EnterpriseManagementSidebar />
            case IconName.USER_MANAGEMENT_SIDEBAR:
                return <UserManagementSidebar />
            case IconName.QUEUE_MANAGEMENT_SIDEBAR:
                return <QueueManagementSidebar />
            case IconName.DEVICES_SIDERBAR:
                return <DeviceSidebar />
            case IconName.AGENTS_SIDEBAR:
                return <AgentSidebar />
            case IconName.PARTITIONS_SIDEBAR:
                return <PartitionSidebar />
            case IconName.CME_SIDEBAR:
                return <CMESidebar />
            case IconName.CODES_SIDEBAR:
                return <CodesSidebar />
            case IconName.DIRECTORY_SIDEBAR:
                return <DirectorySidebar />
            case IconName.USERS_SIDEBAR:
                return <UsersSidebar />
            case IconName.TELSERVERS_SIDEBAR:
                return <TelsysSidebar />
            case IconName.RECORDINGS_SIDEBAR:
                return <RecordingSidebar />
            case IconName.MESSAGE_SIDEBAR:
                return <MessagesSidebar />
            case IconName.DATABASE_SIDEBAR:
                return <DatabaseSidebar />
            case IconName.LICENCES_SIDEBAR:
                return <LicencesSidebar />
            case IconName.LOGGING_SIDEBAR:
                return <LoggingSidebar />
            case IconName.LOG_MANAGEMENT_SIDEBAR:
                return <LogManagementSidebar />
            case IconName.AUDIT_LOGS_SIDEBAR:
                return <AuditTrailSidebar />
            case IconName.CALL_CONTROL_SIDEBAR:
                return <CallControlSidebar />
            case IconName.SERVER_STATUS_SIDEBAR:
                return <ServerStatusSidebar />
            case IconName.TELSYS_MODULE_STATUS_SIDEBAR:
                return <TelephonyModuleStateSidebar />
            case IconName.EXPAND_MENU:
                return <ExpandMenu />
            case IconName.COLLAPSE_MENU:
                return <CollapseMenu />
            case IconName.FAVOURITE:
                return <Favorite />
            case IconName.FAVOURITE_OUTLINED:
                return <FavoriteBorder />
            case IconName.MISSED_CALLS:
                return <MissedCalls />
            case IconName.CALLS_RECEIVED:
                return <CallsReceived />
            case IconName.AVERAGE_ANSWER:
                return <AverageAnswered />
            case IconName.AVERAGE_ABANDONED:
                return <AverageAbandoned />
            case IconName.LONGEST_WAIT:
                return <LongestWait />
            case IconName.BRANDING:
                return <BrandingIcon />
            case IconName.QUEUE_MONITOR_ALL:
                return <QueueMonitorAll />
            case IconName.QUEUE_UNMONITOR_ALL:
                return <QueueUnmonitorAll />
            case IconName.TIMEZONE:
                return <TimeZoneIcon />
            case IconName.ABANDONED_CALL:
                return <AbandonedIcon />
            case IconName.ADVANCED_BOUNCED_CALL:
                return <AdvancedBouncedIcon />
            case IconName.ANSWERED_CALL:
                return <AnsweredIcon />
            case IconName.CALL_ENDED_CALL:
                return <CallEndedIcon />
            case IconName.CALL_STARTED_INBOUND_CALL:
                return <CallStartInboundIcon />
            case IconName.CALL_STARTED_OUTBOUND_CALL:
                return <CallStartOutboundIcon />
            case IconName.CONFERENCED_CALL:
                return <ConferencedIcon />
            case IconName.DIVERTED_CALL:
                return <DivertedIcon />
            case IconName.ENDED_ON_HOLD_CALL:
                return <EndedOnHoldIcon />
            case IconName.ESCAPE_CALL:
                return <EscapedIcon />
            case IconName.MOVED_CALL:
                return <MovedIcon />
            case IconName.OVERFLOWED_CALL:
                return <OverflowedIcon />
            case IconName.TRANSFERRED_CALL:
                return <TransferredIcon />
            case IconName.UNMONITORED_UNKNOWN_DESTINATION_CALL:
                return <UnmonitoredUnknownDestinationIcon />
            case IconName.REPLAY:
                return <Replay />
            case IconName.PREVIEW:
                return <PreviewIcon />
            case IconName.DELETE_PREVIEW:
                return <DeletePreview />
            case IconName.CLEAR_CHANGES:
                return <ClearCurrentChanges />
            default:
                return <div>Icon Not Found</div>
        }
    }

    return (
        <div ref={inputRef} className={`icon-wrapper ${size} ${className ?? ''}`}>
            {getIcon()}
        </div>
    )
}

export default Icon
